function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgE = function SvgE(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 85"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M62.9 85H.4L.2.5h62.6V24l-37.1-2.3.7 16.9L51 35.8l-.3 15-24 .6.4 12.6 38.4-7.4zM3.8 55.8 7 2.6H3zm31.7 9.5 26.8-3.1.2-2.1z",
    style: {
      fill: "#fac03e"
    }
  }));
};
export default SvgE;